export default "__VITE_ASSET__e0be2955__"